// extracted by mini-css-extract-plugin
export default {"container":"L_d","mainTitle":"L_d4","secondaryTitle":"L_d5","signUpButton":"L_d6"};